const UploadIcon = ({ color }: any) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.846155 14C1.31347 14 1.69231 14.3582 1.69231 14.8C1.69231 16.3311 1.6941 17.3989 1.80868 18.2047C1.91998 18.9874 2.12356 19.4018 2.43581 19.6971C2.74805 19.9923 3.18645 20.1847 4.01429 20.29C4.86648 20.3983 5.99595 20.4 7.61539 20.4H14.3846C16.004 20.4 17.1335 20.3983 17.9857 20.29C18.8136 20.1847 19.2519 19.9923 19.5642 19.6971C19.8765 19.4018 20.08 18.9874 20.1914 18.2047C20.3059 17.3989 20.3077 16.3311 20.3077 14.8C20.3077 14.3582 20.6865 14 21.1538 14C21.6211 14 22 14.3582 22 14.8V14.8586C22 16.3173 22 17.4931 21.8686 18.4179C21.7321 19.378 21.44 20.1863 20.7609 20.8284C20.0817 21.4705 19.2268 21.7467 18.2113 21.8757C17.2331 22 15.9895 22 14.4466 22H7.55348C6.01056 22 4.76692 22 3.7888 21.8757C2.77329 21.7467 1.91825 21.4705 1.23916 20.8285C0.560075 20.1863 0.267994 19.378 0.131459 18.4179C-4.4629e-05 17.4931 -2.1973e-05 16.3173 5.91128e-07 14.8586C5.91128e-07 14.839 5.91128e-07 14.8195 5.91128e-07 14.8C5.91128e-07 14.3582 0.378841 14 0.846155 14Z"
        fill={color ? color : "#4D4D4D"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 0C11.266 0 11.5197 0.103782 11.6992 0.285975L16.7518 5.41529C17.1048 5.77369 17.0781 6.32989 16.6919 6.65758C16.3058 6.98527 15.7065 6.96036 15.3535 6.60196L11.9474 3.14418V16.1207C11.9474 16.6063 11.5232 17 11 17C10.4768 17 10.0526 16.6063 10.0526 16.1207V3.14418L6.64656 6.60196C6.29351 6.96036 5.69427 6.98527 5.30812 6.65758C4.92198 6.32989 4.89513 5.77369 5.24819 5.41529L10.3008 0.285975C10.4803 0.103782 10.734 0 11 0Z"
        fill={color ? color : "#4D4D4D"}
      />
    </svg>
  );
};

export default UploadIcon;
